import { render, staticRenderFns } from "./delete-custom-luts-folder.vue?vue&type=template&id=1a9531f6&"
import script from "./delete-custom-luts-folder.vue?vue&type=script&lang=js&"
export * from "./delete-custom-luts-folder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports